import { render, staticRenderFns } from "./MembershipRegistration.vue?vue&type=template&id=0fbcc13d&scoped=true&"
import script from "./MembershipRegistration.vue?vue&type=script&lang=js&"
export * from "./MembershipRegistration.vue?vue&type=script&lang=js&"
import style0 from "./MembershipRegistration.vue?vue&type=style&index=0&id=0fbcc13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbcc13d",
  null
  
)

export default component.exports